// @flow

import React, { type Node } from 'react';
import { useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getSafeAchPseInfo } from '@tectonics/prs/incoming-payment/get-ach-pse-info';

export function TicketCus(): Node {
  const incomingPayment = useIncomingPayment();
  const achPseInfo = getSafeAchPseInfo(incomingPayment);
  const cus = achPseInfo['CUS'];

  return (
    <td data-testid="display-cus">{ cus }</td>
  );
}
